import { Module } from 'vuex';
import { IAccount } from '@/shared/model/account.model';

interface AccountStoreState {
  logon: boolean;
  account: IAccount;
  authenticated: boolean;
  ribbonOnProfiles: string;
  activeProfiles: string;
  showFirstLogin: boolean;
}

export const accountStore: Module<AccountStoreState, any> = {
  state: {
    logon: false,
    account: null as IAccount,
    authenticated: false,
    ribbonOnProfiles: '',
    activeProfiles: '',
    showFirstLogin: true
  },
  getters: {
    logon: state => state.logon,
    account: state => state.account,
    authenticated: state => state.authenticated,
    activeProfiles: state => state.activeProfiles,
    ribbonOnProfiles: state => state.ribbonOnProfiles,
    showFirstLogin: state => state.showFirstLogin
  },
  mutations: {
    authenticate(state) {
      state.logon = true;
    },
    authenticated(state, account: IAccount) {
      state.account = account;
      state.authenticated = true;
      state.logon = false;
      state.showFirstLogin = account.firstLogin === null ? true : false;
    },
    logout(state) {
      state.account = null;
      state.authenticated = false;
      state.logon = false;
    },
    setActiveProfiles(state, profile) {
      state.activeProfiles = profile;
    },
    setRibbonOnProfiles(state, ribbon) {
      state.ribbonOnProfiles = ribbon;
    },
    setShowFirstLogin(state, showFirstLogin) {
      state.showFirstLogin = showFirstLogin;
    }
  }
};
